import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	notificationMessage: {
		padding: theme.spacing(0.5, 1.5),
		maxWidth: "none",
		textAlign: "center"
	},
	blueNotification: {
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[100])
	},
	orangeNotification: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[100])
	},
	grayNotification: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
	},
	whiteNotification: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0])
	},
	messageText: {
		fontSize: 12
	},
	messageContent: {
		position: "relative",
		borderRadius: theme.spacing(1),
		boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.25)",
		wordBreak: "break-word"
	}
}))

export default useStyles
